export default "__VITE_ASSET__CJLTG54K__"